module.exports = __webpack_public_path__ + "static/img/light-01.cf7e382.png";